export default "__VITE_ASSET__CnQSnfpR__"